import script from "./ComplexSelection.button.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComplexSelection.button.vue?vue&type=script&lang=ts&setup=true"

import "./ComplexSelection.button.vue?vue&type=style&index=0&id=54eb89e0&lang=scss&scoped=true"

import exportComponent from "/home/forge/usta.ge/vue-application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54eb89e0"]])

export default __exports__